import React from 'react';

const StepIndicator = ({currentStep, totalSteps = 3}) => {
    const steps = Array.from({length: totalSteps}, (_, i) => i + 1);

    return (
        <div className="flex items-center w-full gap-0">
            {steps.map((step) => (
                <React.Fragment key={step}>
                    <div
                        className={`flex items-center justify-center w-7 h-7 rounded text-xs font-bold flex-shrink-0 ${
                            step <= currentStep
                                ? 'bg-classic-button-normal text-classic-button-normal-text'
                                : 'bg-panels-normal text-main-disabled'
                        }`}
                    >
{step}
                    </div>
                    {step < totalSteps && (
                        <div className={`flex-1 h-0.5 ${step < currentStep ? 'bg-classic-button-normal' : 'bg-panels-normal'}`} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default StepIndicator;
